import gql from "graphql-tag";
export const GET_TICKETS_BY_ORG_ID = gql`
  query orgTicketByOrgId($orgId: ID!,$title_Icontains: String,$createdAt_Range: [DateTime],$priority: Int,$first: Int,$status: String,$status_In: [String],$offset: Int){
    orgTicketByOrgId(orgId:$orgId,title_Icontains:$title_Icontains,createdAt_Range:$createdAt_Range,priority:$priority,first:$first,status:$status,status_In: $status_In,offset:$offset){
        totalCount
            pageInfo{
            hasNextPage
            endCursor
        }
        edges {
            node{
                id
                title
                description
                createdAt
                attachments
                status
                priority
                updatedAt
                workitemId
                raisedBy{
                id
                firstName
                lastName
                }
            }
        }
    }
}
`;